export default __webpack_public_path__ + "static/star_b.bf197f9e7abab785ab160dd3e814d4c6.svg";